import {ApiService} from "./api.service";


export class OrgMemberService extends ApiService{

  constructor(organizationId) {
    super();
    this.endpoint = `/organizations/${organizationId}/org_members`;
    this.per = 10;
  }
}
